import isProduction from '../../common/helpers/is-production';
import appStoreCreate from './create';

const store = appStoreCreate(isProduction());

export default function appStoreFactory(): typeof store {
  return store;
}
